module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-dune-timber-balmoral-0.2105bda1.jpg";